export enum ImportMode {
    CSV = 'Csv',
    MICROCAT = 'Microcat',
}
